module.exports = __webpack_public_path__ + "static/media/dropdown_icon.34d36ff6.svg";